const theme = {
  primary: '#11ADD6',
  primaryLight: '#FC0065',
  primaryDark: '#9a0007',
  secondary: '#e0e0e0',
  secondaryLight: '#ffffff',
  secondaryDark: '#aeaeae',
  white: '#ffffff',
  black: '#000000',
  twitterBootstrap: {
    primary: '#017BEE',
    secondary: '#7F878E',
    success: '#29A745',
    danger: '#DC3645',
    warning: '#FFC20E',
    info: '#17A2B8'
  },
  custom: {}
}

export default theme
